import { createFileRoute } from "@tanstack/react-router";

import { PageDescription } from "#/components/PageDescription";
import { PageEyeBrow } from "#/components/PageEyeBrow";
import { PageHeader } from "#/components/PageHeader";
import { PageIntro } from "#/components/PageIntro";
import { PageShell } from "#/components/PageShell";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

import { CodexDamageCalculatorSection } from "./-codex.damageCalculator";
import { CodexDamageMatrixTable } from "./-codex.damageMatrix";
import { CodexGuideSections } from "./-codex.guide";
import { CodexTilesTable, CodexUnitsTable } from "./-codex.sections";

export const Route = createFileRoute("/codex")({
  head: () => documentHead(DOCUMENT_TITLES.codex),
  component: CodexPage,
});

function CodexPage() {
  return (
    <PageShell>
      <PageIntro align="start">
        <PageEyeBrow>Get to know Daily Wars</PageEyeBrow>
        <PageHeader>Game Guide</PageHeader>
        <PageDescription>
          New to Daily Wars? The guide gives you an overview of the game mechanics, available units,
          terrain, and more.
        </PageDescription>
      </PageIntro>
      <div className="mt-2 flex flex-col gap-10">
        <CodexGuideSections />
        <CodexUnitsTable />
        <CodexTilesTable />
        <CodexDamageCalculatorSection />
        <CodexDamageMatrixTable />
      </div>
    </PageShell>
  );
}
